import { render, staticRenderFns } from "./importCompany.vue?vue&type=template&id=0f5778cc&scoped=true"
import script from "./importCompany.vue?vue&type=script&lang=js"
export * from "./importCompany.vue?vue&type=script&lang=js"
import style0 from "./importCompany.vue?vue&type=style&index=0&id=0f5778cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5778cc",
  null
  
)

export default component.exports